export default function MuiAutoComplete(theme: any) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          backgroundColor: theme.palette.grey[700],
          borderRadius: theme.shape.borderRadius * 4,
          padding: theme.spacing(1, 0.25, 0, 0.25),
        },
      },
    },
  };
}
